export default "__VITE_ASSET__516bdb38__"